import React from 'react';

export const absChange = {
    body: <span>Price change from Prev Close</span>,
};

export const percChange = {
    body: <span>Price change in % from Prev Close</span>,
};
